import { NoShowRateByType } from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import { Chart } from '@frontend/charts';
import { i18next, useTranslation } from '@frontend/i18n';
import { useScopedAppFlagStore } from '@frontend/scope';
import { featureFlags } from '../../../../feature-flags';
import { NSRRoiBenchmarkTimelineChart } from '../charts/nsr-roi-benchmark-timeline-chart';
import { NSRRoiComparisonByProviderChart } from '../charts/nsr-roi-comparison-by-provider-chart';
import { NSRRoiConfirmationStatusTimelineChart } from '../charts/nsr-roi-confirmation-status-timeline-chart';
import { NSRRoiGroupComparisonChart } from '../charts/nsr-roi-group-comparison-chart';
import { NSRRoiPatientsTypeTimelineChart } from '../charts/nsr-roi-patients-type-timeline-chart';
import { NSRRoiTopRepeatComparisonChart } from '../charts/nsr-roi-top-repeat-comparison-chart';

// Translation not needed as days of the week are used for sorting and matching backend keys
const weekDaysSequence = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const dayByWeekHighlightDescription = (highlight: string) => {
  return i18next.t('Include an additional reminder for appointments scheduled on {{highlight}}', {
    highlight,
  });
};

const appointmentTypeHighlightDescription = (highlight: string) => {
  return i18next.t(
    'Identify high no-show types like {{highlight}} and optimize reminders filtered by appointment type',
    {
      highlight,
      ns: 'analytics',
    }
  );
};

export const NSRRoiDashboardSingle = () => {
  const { t } = useTranslation('analytics');

  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const isDemoAccount = getFeatureFlagValue(featureFlags.noShowRateRoiDemoData);

  return (
    <>
      <NSRRoiBenchmarkTimelineChart />
      <Chart.HorizontalContainer marginBottom={0}>
        <NSRRoiPatientsTypeTimelineChart />
        <NSRRoiConfirmationStatusTimelineChart />
      </Chart.HorizontalContainer>

      <Chart.HorizontalContainer marginBottom={0}>
        <NSRRoiGroupComparisonChart
          highlightDescription={dayByWeekHighlightDescription}
          infoText={t('Track no-shows by day of the week')}
          isDemoAccount={isDemoAccount}
          keysSequence={weekDaysSequence}
          noShowRateType={NoShowRateByType.DAY_WISE}
          title={t('No-Show Rate by Day of the Week')}
        />
        <NSRRoiTopRepeatComparisonChart isDemoAccount={isDemoAccount} />
      </Chart.HorizontalContainer>
      <Chart.HorizontalContainer marginBottom={0}>
        <NSRRoiComparisonByProviderChart isDemoAccount={isDemoAccount} />
        <NSRRoiGroupComparisonChart
          highlightDescription={appointmentTypeHighlightDescription}
          infoText={t('Track no-shows by appointment type')}
          isDemoAccount={isDemoAccount}
          noShowRateType={NoShowRateByType.APPOINTMENTS_EXTERNAL_TYPE}
          title={t('No-Show Rate by Appointment Type')}
        />
      </Chart.HorizontalContainer>
    </>
  );
};
